<span *ngIf="!confirm" class="btn btn-red btn-circle btn-sm">
    <i class="fas fa-fw fa-times"></i>
</span>
<span *ngIf="confirm" class="btn btn-green btn-circle btn-sm">
    <i class="fas fa-fw fa-check"></i>
</span>
